<div>
    <app-precipitation-svg [height]="'35'" [online]="true" [width]="'35'" style="margin: auto"></app-precipitation-svg>
    <div style="font-size: var(--main-font-size);
                color: #FFFFFF;
                margin: auto;
                text-align: center;
                justify-content: center;
                text-shadow: 1px 0 0 #000, 0 -1px 0 #000, 0 1px 0 #000, -1px 0 0 #000;">{{ name }}
    </div>
</div>